<template>
  <b-container fluid>
    <b-row v-if="orders && orders.length > 0" class="h-100">
      <b-col xl="6">
        <OrderList />
      </b-col>

      <b-col v-if="selectedOrder" xl="6" class="h-100" align-self="stretch">
        <OrderPreview />
      </b-col>
    </b-row>
    <div v-else-if="fetchOrdersError">
      <Error v-bind:errorMessage="fetchOrdersError" />
    </div>
  </b-container>
</template>

<script>
import OrderList from "../components/orders/OrderList";
import OrderPreview from "../components/orders/OrderPreview";
import Error from "../components/shared/Error";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Orders",
  components: {
    OrderList,
    OrderPreview,
    Error,
  },

  computed: {
    ...mapGetters(["orders", "fetchOrdersError", "selectedOrder"]),
  },

  methods: {},
};
</script>

<style scoped>
.container-fluid {
  height: 60vh;
}
</style>
